import { useDataSourceColumns } from "@/hooks";
import type { SortTransformer } from "@/types/workspace";
import { Flex, Select } from "@mantine/core";
import { useEffect, useState } from "react";
import { TransformerBase } from "./TransformerBase";

export function TransformerSort({
  data,
  warning,
  error,
  onUpdate,
  index,
}: {
  data: SortTransformer;
  warning?: string;
  error?: string;
  onUpdate?: (updatedData: SortTransformer) => void;
  index: number;
}) {
  const [column, setColumn] = useState(data.item_list[0] || "");
  const availableColumns = useDataSourceColumns(index);

  useEffect(() => {
    setColumn(data.item_list[0] || "");
  }, [data.item_list]);

  const handleChange = (value: string | null) => {
    if (value !== null) {
      setColumn(value);
      if (onUpdate) {
        onUpdate({
          ...data,
          item_list: [value],
        });
      }
    }
  };

  return (
    <TransformerBase warning={warning} error={error}>
      <Flex direction="row" gap={8}>
        <Select
          flex={1}
          variant="light"
          bdrs="sm"
          bg="#F1F3F4"
          placeholder="Column"
          data={availableColumns.length > 0 ? availableColumns : []}
          value={column}
          onChange={handleChange}
        />
      </Flex>
    </TransformerBase>
  );
}
